import { Button } from "@endya-conformite/ui-kit";
import XLg from "@endya-conformite/ui-kit/src/assets/icons/x-lg.svg?react";
import Loader from "@endya-conformite/ui-kit/src/assets/loader.svg?react";
import { ID_FORM_SOCIETE_INFORMATION } from "./SocieteInformation";
import styles from "./SocieteInformationActions.module.scss";

type SocieteInformationActionsProps = {
  isLoading: boolean;
  onCancel: () => void;
};
export function SocieteInformationActions({
  isLoading,
  onCancel,
}: SocieteInformationActionsProps) {
  return (
    <div className={styles.actions}>
      <Button onClick={onCancel} variant="text" icon={<XLg />}>
        Annuler les modifications
      </Button>
      <Button
        type="submit"
        form={ID_FORM_SOCIETE_INFORMATION}
        icon={isLoading ? <Loader /> : undefined}
        disabled={isLoading}
      >
        Enregistrer
      </Button>
    </div>
  );
}
